// Conditional webfont loader, locale-aware.
//
// Latin-script locales (en, es, pt-BR, fr, de, id) inherit the system stack —
// no payload. `hi` needs Devanagari glyphs, `ur` needs Arabic glyphs; the
// Fontsource @400/@700 subsets are dynamic-imported only when those locales
// activate so the en-only bundle never ships them. Repeat calls are a no-op.

const loaded = new Set();

export function loadFontForLocale(locale) {
  if (!locale || loaded.has(locale)) return;
  loaded.add(locale);
  if (locale === 'hi') {
    import('@fontsource/noto-sans-devanagari/400.css');
    import('@fontsource/noto-sans-devanagari/700.css');
  } else if (locale === 'ur') {
    import('@fontsource/noto-sans-arabic/400.css');
    import('@fontsource/noto-sans-arabic/700.css');
  }
}

// System font stack shared by every locale. MUI's default is Roboto (which
// we don't load), so an explicit system stack keeps the chrome consistent
// across devices when Roboto isn't available.
export const SYSTEM_FONT_STACK =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export function fontFamilyForLocale(locale) {
  if (locale === 'hi') return `'Noto Sans Devanagari', ${SYSTEM_FONT_STACK}`;
  if (locale === 'ur') return `'Noto Sans Arabic', ${SYSTEM_FONT_STACK}`;
  return SYSTEM_FONT_STACK;
}
